import { Title } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_admin/settings')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <>
      <Title order={1} mb="md">
        Ustawienia
      </Title>
    </>
  )
}
